import HistoryEntry from './HistoryEntry';

export default HistoryEntry;
